import { registerComponent } from '../app'
import { VARIANT_CHANGE } from '../events'

const VariantTextColor = (scope, el) => {
	scope.on(VARIANT_CHANGE, variant => {
		if (!variant.primary_color || !variant.primary_color.length) return
		el.style.color = variant.primary_color
	})
}

registerComponent('variant-text-color', VariantTextColor)
